import { CodeMirrorMarkDownEditor } from './CodeMirrorMarkDownEditor';
import { MarkDownEditor } from './MdeMarkDownEditor';

export default MarkDownEditor;
export const NewTextEdit = CodeMirrorMarkDownEditor;
